"use client";

import { useIframeManager } from "@/hooks/useIframeManager";

export default function AppInitializer() {
  useIframeManager();
  return null; // This component doesn't render anything
}
